<template>
  <div class="xc-page xc-page-sandwich" ref="mainHeight">
    <div class="xc-page-main xc-flex-point">
      <!-- 面包屑 -->
      <div class="xc-breadcrumb">
        <router-link :to="$config.adminPath + '/program'">节目管理</router-link>
        <a>添加节目</a>
        <a>选点</a>
      </div>
      <xc-step :step-value="stepValue"></xc-step>

      <!-- 选择终端 -->
      <div
        class="xc-card xc-s-flex xc-s-df"
        v-show="currentStep == 0"
        style="overflow: hidden"
      >
        <div class="device-group">
          <div class="xc-card-header">
            <div class="xc-card-title">终端组</div>
          </div>

          <!-- 树形目录 -->
          <div class="tree xc-s-p">
            <xc-tree
              :data.sync="deviceGroups"
              label="name"
              @checked="deviceGroupChecked"
              @selected="selectFunc"
              show-checkbox
              linked
              :expand="0"
              multiple
              :key="deviceGroups.length"
            ></xc-tree>
          </div>
        </div>

        <!-- 隐藏的数据 -->
        <span style="display: none">
          {{ selectCount }}
        </span>

        <!--  带滚动条表格 -->
        <div class="xc-card xc-s-flex" style="overflow: auto">
          <div class="xc-card-content">
            <form class="xc-form">
              <div class="xc-form-inline">
                <xc-form-item label="终端名">
                  <input
                    type="text"
                    name="deviceName"
                    v-model="search.deviceName"
                    maxlength="255"
                    class="xc-input"
                    placeholder="请输入终端名称"
                  />
                </xc-form-item>
                <xc-form-item label="在线状态">
                  <select
                    class="xc-select"
                    name="deviceStatus"
                    v-model="search.deviceStatus"
                  >
                    <option value="">全部</option>
                    <option value="0">在线</option>
                    <option value="1">离线</option>
                  </select>
                </xc-form-item>
                <xc-form-item label="MAC">
                  <input
                    type="text"
                    name="deviceMac"
                    v-model="search.deviceMac"
                    maxlength="255"
                    class="xc-input"
                    placeholder="请输入MAC"
                  />
                </xc-form-item>
                <xc-form-item label="IP">
                  <input
                    type="text"
                    name="ip"
                    v-model="search.ip"
                    maxlength="255"
                    class="xc-input"
                    placeholder="请输入IP"
                  />
                </xc-form-item>
                <div class="xc-btn-group">
                  <button
                    type="submit"
                    class="xc-btn xc-btn-primary"
                    @click.prevent="getList()"
                  >
                    查询
                  </button>
                </div>
              </div>
            </form>

            <!-- 带滚动条的表格 -->
            <table class="xc-table">
              <thead>
                <tr @click.stop="checkAllChange" style="cursor: pointer">
                  <th>
                    <input
                      type="checkbox"
                      class="xc-checkbox"
                      :checked="checkAll"
                    />
                  </th>
                  <th>终端名</th>
                  <!-- <th>设备IP</th> -->
                  <th>设备MAC</th>
                  <th>门店名</th>
                  <th>在线状态</th>
                  <th>设备类型</th>
                  <th>设备尺寸</th>
                  <th>分辨率</th>
                  <th>机型</th>
                  <th>安装位置</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="list && list.length">
                  <tr
                    v-for="(item, key) in list"
                    :key="key"
                    @click.stop="deviceChecked(item)"
                    style="cursor: pointer"
                  >
                    <td style="width: 45px">
                      <input
                        type="checkbox"
                        class="xc-checkbox"
                        :checked="selectDevice[item.deviceCode]"
                      />
                    </td>
                    <td>
                      {{ item.deviceName }}
                    </td>
                    <!-- <td>
                                          {{item.lastReportIp}}
                                      </td> -->
                    <td>
                      {{ item.deviceMac }}
                    </td>
                    <td>
                      {{ item.storeName }}
                    </td>
                    <td>
                      {{ item.deviceStatus }}
                    </td>
                    <td>
                      {{ item.deviceType }}
                    </td>
                    <td>
                      {{ item.screenSize }}
                    </td>
                    <td>
                      {{ item.resolvingPower }}
                    </td>
                    <td>
                      {{ item.model }}
                    </td>
                    <td>
                      {{ item.deviceLocation }}
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="9" class="xc-s-tac">请选择终端</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!--  终端确认 -->
      <div
        class="xc-row xc-s-flex"
        style="overflow: auto; background: #ffffff; margin-bottom: 0"
        v-show="currentStep == 1"
      >
        <div class="xc-card">
          <div class="xc-card-content">
            <div class="xc-form-inline xc-form-inline-resete">
              <div>
                共{{ selectCount }}条数据, 共{{ groupCount }}个分组,
                {{ selectCount }}个终端, 经办人：{{ programInfo.addUserName }}
              </div>
            </div>

            <!-- 带滚动条的表格 -->
            <div class="xc-row-scroll">
              <table class="xc-table">
                <thead>
                  <tr>
                    <th>终端组</th>
                    <th>终端名</th>
                    <th>设备IP</th>
                    <th>设备MAC</th>
                    <th>在线状态</th>
                    <th>设备类型</th>
                    <th>设备尺寸</th>
                    <th>分辨率</th>
                    <th>机型</th>
                    <th>安装位置</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-if="selectDeviceArray && selectDeviceArray.length"
                  >
                    <tr v-for="(item, key) in selectDeviceArray" :key="key">
                      <td>
                        {{ item.groupName }}
                      </td>
                      <td>
                        {{ item.deviceName }}
                      </td>
                      <td>
                        {{ item.lastReportIp }}
                      </td>
                      <td>
                        {{ item.deviceMac }}
                      </td>
                      <td>
                        {{ item.deviceStatus }}
                      </td>
                      <td>
                        {{ item.deviceType }}
                      </td>
                      <td>
                        {{ item.screenSize }}
                      </td>
                      <td>
                        {{ item.resolvingPower }}
                      </td>
                      <td>
                        {{ item.model }}
                      </td>
                      <td>
                        {{ item.deviceLocation }}
                      </td>
                      <td class="xc-link">
                        <a @click="deviceChecked(item)">删除</a>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="9" class="xc-s-tac">暂无数据</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!--发布成功-->
      <div
        class="xc-row xc-s-flex"
        style="overflow: hidden"
        v-show="currentStep == 2 && publishResult == 1"
      >
        <div class="xc-card complete">
          <div class="result success">
            <img src="@/assets/program/icon-success.png" />
            <div class="tips">发布申请提交成功</div>
            <div class="xc-info" v-if="programCheck">
              <div class="xc-info-content">
                <div class="xc-info-row">
                  该节目需要审核，请耐心等待相关人员审核
                </div>
                <!-- <div class="xc-info-row">
                                      <router-link
                                          class="action check"
                                          :to="$config.adminPath + '/program/' + programVersion + '/check'"
                                      >去审核</router-link>
                                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--发布失败-->
      <div
        class="xc-row xc-s-flex"
        style="overflow: hidden"
        v-show="currentStep == 2 && publishResult == 0"
      >
        <div class="xc-card complete">
          <div class="result fail">
            <img src="@/assets/program/icon-error.png" />
            <div class="tips">发布申请提交失败</div>
            <div class="xc-info">
              <div class="xc-info-content">
                <div class="xc-info-row">
                  {{ publishResultMsg }}
                </div>
                <!-- <div class="xc-info-row">
                                      <div class="action check" @click="check">去审核</div>
                                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 固低栏 -->
    <!-- <div class="xc-page-footer">
              <div class="xc-btn-group">
                  <div
                      class="xc-btn xc-btn-default"
                      @click="preStep"
                      v-if="currentStep==1"
                  >上一步</div>
                  <div
                      class="xc-btn xc-btn-primary"
                      @click="nextStep"
                      v-if="currentStep!=2"
                  >下一步</div>
                  <router-link
                      class="xc-btn xc-btn-primary"
                      :to="$config.adminPath + '/device/apk'"
                      v-if="currentStep==2"
                  >完成</router-link>
              </div>
          </div> -->

    <div class="xc-page-footer">
      <div class="xc-btn-group">
        <div
          class="xc-btn xc-btn-default"
          @click.prevent="preStep"
          v-if="currentStep == 1"
        >
          上一步
        </div>
        <div
          class="xc-btn xc-btn-primary"
          @click.prevent="nextStep"
          v-if="currentStep == 0"
        >
          下一步
        </div>
        <div
          class="xc-btn xc-btn-primary"
          @click.prevent="nextStep"
          v-if="currentStep == 1"
        >
          发布
        </div>
        <!-- <router-link
                      class="xc-btn xc-btn-primary"
                      :to="$config.adminPath + '/program'"
                      v-if="currentStep==2"
                  >完成</router-link> -->
        <a class="xc-btn xc-btn-primary" v-if="currentStep == 2" @click="close"
          >完成</a
        >
      </div>
    </div>
  </div>
</template>
  
  <script>
import myLayerImport from "@/libs/myLayer";
import deviceApi from "@/api/device";
import programApi from "@/api/program";
import { mapState, mapActions } from "vuex";
// ip格式化
import "@/utils/ip-format";

export default {
  name: "deviceApkUpgrade",
  data() {
    return {
      currentStep: 0,
      programVersion: this.$route.params.programVersion,
      stepValue: [
        {
          text: "选择终端",
          active: true,
        },
        {
          text: "终端确认",
        },
        {
          text: "发布完成",
        },
      ],

      // 列表
      list: [],
      // 终端分组
      deviceGroups: [],
      // 弹出窗
      modalName: null,
      // 搜索类型
      searchType: "mac",
      // 搜索
      search: {
        deviceStatus: "",
      },
      // 选择的终端
      selectDevice: {},
      // 从详情中获取到的，初始化渲染用
      selectDeviceCode: {},
      groupCount: 0,
      // 节目详情
      programInfo: {},
      // 发布结果
      publishResult: 0,
      publishResultMsg: "",
      clientHeight: "",
      pointType:'', //选点类型  addPoint:追加设备
    };
  },
  created() {
    if(this.$route.query.param1){
      this.pointType = this.$route.query.param1; //追加设备
    }
    // 详情
    programApi
      .programDetail({ programVersion: this.$route.params.programVersion })
      .then((ret) => {
        this.programInfo = ret.data;
        this.search.resolvingPower = ret.data.deviceResolution.split(",");
        this.getTree(ret.data.deviceResolution.split(","));
        const selectDeviceCode = {};
        this.programInfo.deviceList.map((v) => {
          selectDeviceCode[v.deviceCode] = v.deviceCode;
        });
        this.selectDeviceCode = selectDeviceCode;
        this.getList(null, true);
      });
  },

  methods: {
    // 获取终端分组
    getTree(resolvingPower) {
      deviceApi
        .getDeviceGroup({
          mediaType: "audio",
          resolvingPower: "NOT",
        })
        .then((v) => {
          this.deviceGroups = v.data;
          this.ergodicTree(this.deviceGroups);
        });
    },

    // 遍历树
    ergodicTree(data) {
      const treeList = {};

      /**
       * 把数组转换成一维对象
       */
      (function toObject(list) {
        list.map((item) => {
          item.deviceTotal = item.deviceCount;
          if (!item.id) {
            item.id = 1;
          }
          treeList[item.id] = item;
          if (item.children && item.children.length) {
            toObject(item.children);
          }
        });
      })(data);

      /**
       * 给所有父元素增加数量
       */
      const setParentTotal = (item, deviceCount) => {
        if (item.parentId) {
          const parent = treeList[item.parentId];
          const curDeviceCount = deviceCount || item.deviceCount;
          parent.deviceTotal += curDeviceCount;
          if (curDeviceCount) setParentTotal(parent, curDeviceCount);
        }
      };

      // 遍历一次对象
      for (const key in treeList) {
        if (treeList.hasOwnProperty(key)) {
          const item = treeList[key];
          setParentTotal(item);
        }
      }

      for (const key in treeList) {
        if (treeList.hasOwnProperty(key)) {
          const item = treeList[key];
          item.name += "(" + item.deviceTotal + ")";
        }
      }
    },

    // 初始化数据
    getList(checkAll, ready = false) {
      // 默认搜索的数据
      const search = {
        pageNum: 1,
        pageSize: 0,
        ...this.search,
        mediaType: "audio",
      };

      return deviceApi.getDeviceList(search).then((ret) => {
        const list = ret.data.list;
        const selectDevice = {
          ...this.selectDevice,
        };

        // 初始化时将选点数据选中
        if (ready) {
          list.map((item) => {
            if (this.selectDeviceCode[item.deviceCode]) {
              selectDevice[item.deviceCode] = item;
            }
          });

          this.selectDevice = selectDevice;
        }

        // 全选
        if (checkAll) {
          list.map((item) => {
            selectDevice[item.deviceCode] = item;
          });

          this.selectDevice = selectDevice;
        }
        this.list = list;
      });
    },

    /**
     * 终端分组选择
     */
    deviceGroupChecked(tree) {
      console.log(tree);
      const { checked } = tree;
      const groupId = [];
      checked.map((item) => {
        groupId.push(item.id);
      });

      var id = tree.target.id;
      var chilren = tree.target.children;
      var ids = this.getIds(chilren, []);
      ids.push(id);
      console.log(ids);
      this.search.groupId = ids.join(",");

      //取消选中
      if (!tree.target.checked) {
        this.noChecked().then(() => {
          this.search.groupId = groupId.join(",");
          this.getList();
        });
      } else {
        //选中
        const checkAll = true;
        this.getList(checkAll).then(() => {
          this.search.groupId = groupId.join(",");
          this.getList();
        });
      }
    },

    //终端组取消选中
    noChecked() {
      // 默认搜索的数据
      const params = {
        pageNum: 1,
        pageSize: 0,
        ...this.search,
      };
      return deviceApi.getDeviceList(params).then((ret) => {
        const list = ret.data.list;
        console.log(list);
        const selectDevice = {
          ...this.selectDevice,
        };
        list.map((item) => {
          if (selectDevice[item.deviceCode]) {
            delete selectDevice[item.deviceCode];
          }
        });
        this.selectDevice = selectDevice;
        this.list = list;
      });
    },

    //点击文字的回调
    selectFunc(data) {
      var children = data.children;
      var ids = this.getIds(children, []);
      ids.push(data.id);
      this.search.groupId = ids.join(",");
      this.getList();
    },

    //遍历children获取groupId
    getIds(arr, ids) {
      if (arr.length) {
        for (let x of arr) {
          ids.push(x.id);
          this.getIds(x.children, ids);
        }
      }
      return ids;
    },

    // 下一步
    nextStep() {
      let stepLen = this.stepValue.length;
      let cur = this.currentStep;
      const next = () => {
        if (cur < stepLen - 1) {
          this.$set(this.stepValue[cur + 1], "active", true);
        }

        this.$set(this.stepValue[cur], "complete", true);
        this.currentStep++;
      };
      if (cur == 0) {
        if (!this.selectCount) return this.$message.error("请先选择终端");
      } else if (cur == 1) {
        const deviceCodes = this.selectDeviceArray.map((v) => {
          return v.deviceCode;
        });

        let requestUrl = 'publishProgram'
        if(this.pointType== 'addPoint'){
          requestUrl = 'appendDevice'
        }
        programApi[requestUrl]({
          deviceCodes: deviceCodes.join(","),
          programVersion: this.$route.params.programVersion,
        })
        .then((v) => {
          this.publishResult = 1;
          next();
        })
        .catch((e) => {
          this.publishResult = 0;
          this.publishResultMsg = e[0];
          next();
        });
        return;
      }
      if (cur >= stepLen) {
        // 结束操作
        return;
      }
      next();
    },

    // 上一步
    preStep() {
      let stepLen = this.stepValue.length;
      let cur = this.currentStep;
      if (cur <= 0) {
        // 结束操作
        return;
      }
      if (cur > -1 && cur < stepLen) {
        this.$set(this.stepValue[cur], "active", false);
      }
      this.$set(this.stepValue[cur - 1], "complete", false);
      this.currentStep--;
    },

    // 设备选中
    deviceChecked(item) {
      const selectDevice = {
        ...this.selectDevice,
      };
      if (selectDevice[item.deviceCode]) {
        delete selectDevice[item.deviceCode];
      } else {
        selectDevice[item.deviceCode] = item;
      }
      this.selectDevice = selectDevice;
    },

    checkAllChange() {
      const selectDevice = {
        ...this.selectDevice,
      };
      this.list.map((item) => {
        if (this.checkAll) {
          delete selectDevice[item.deviceCode];
        } else {
          selectDevice[item.deviceCode] = item;
        }
      });
      this.selectDevice = selectDevice;
    },

    close: function () {
      parent.myLayer.close(this.index);
    },
  },
  async mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    if (this.$refs.mainHeight) {
      this.$refs.mainHeight.style.height = this.clientHeight + "px";
    }
    console.log("mainHeight", this.$refs.mainHeight);
    console.log("clientHeight", this.clientHeight);
    await myLayerImport();
    this.index = parent.myLayer.getFrameIndex(window.name);
  },
  computed: {
    ...mapState(["globalConfig"]),

    // 节目是否需要审核
    programCheck() {
      if (
        this.globalConfig.needAuthProgram &&
        this.globalConfig.needAuthProgram.value == "true"
      ) {
        return true;
      } else {
        false;
      }
    },

    // 是否全选
    checkAll() {
      if (Object.keys(this.selectDevice).length == 0 || this.list.length == 0) {
        return false;
      }

      // 判断是否有没有选中的数据
      let notAll = this.list.some((item) => {
        return this.selectDevice[item.deviceCode] == undefined;
      });
      return notAll ? false : true;
    },

    selectCount() {
      const selectCount = Object.keys(this.selectDevice).length;
      this.stepValue[0].text = `选择终端(${selectCount})`;
      return selectCount;
    },

    selectDeviceArray() {
      // 计算一下分组数量
      const groupCount = {};
      const selectDeviceArray = Object.keys(this.selectDevice).map((key) => {
        const item = this.selectDevice[key];
        groupCount[item.groupName] = item.groupName;
        return item;
      });
      this.groupCount = Object.keys(groupCount).length;
      return selectDeviceArray;
    },
  },
};
</script>
  
  <style scoped lang="scss">
// .list {
// 	height: 100%;
// 	display: flex;
// 	flex-direction: column;
// 	.list-table {
// 		flex: 1;
// 		width: max-content;
// 	}
// }
.xc-page-sandwich {
  display: flex;
}

.xc-flex-point {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.xc-s-df {
  flex: 1;
}

.device-group {
  width: 300px;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .tree {
    flex: 1;
  }
}

.action {
  height: 32px;
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 1px #cfd5e0;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #507dde;
  padding: 0 10px;
  cursor: pointer;

  img {
    margin-right: 3px;
  }
}

.complete {
  display: flex;
  justify-content: center;
  padding-bottom: 30px;

  .result {
    margin-top: 61px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 86px;
      height: 86px;
    }

    .tips {
      font-size: 18px;
      color: #6e7a90;
      line-height: 18px;
      margin: 12px 0;
    }

    .xc-info-content {
      font-size: 14px;
      color: #b6bcc7;

      .xc-info-row {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
  